import { useEffect, useRef, useState } from 'react';

/**
 * @param {{
 *   tabs: Array<{ id: string, label: string }>,
 *   active: string,
 *   onChange: (id: string) => void,
 *   overflow?: Array<{ id: string, label: string }>,
 * }} props
 */
export function WorkspaceTabs({ tabs, active, onChange, overflow = [] }) {
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);
  const overflowActive = overflow.some((tab) => tab.id === active);

  useEffect(() => {
    if (!moreOpen) {
      return undefined;
    }
    const onDoc = (event) => {
      if (!moreRef.current?.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [moreOpen]);

  return (
    <div className="workspace-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={active === tab.id ? 'workspace-tab active' : 'workspace-tab'}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
      {overflow.length ? (
        <div className="workspace-tabs-more" ref={moreRef}>
          <button
            type="button"
            role="tab"
            aria-selected={overflowActive}
            aria-expanded={moreOpen}
            className={overflowActive ? 'workspace-tab active' : 'workspace-tab'}
            onClick={() => setMoreOpen((open) => !open)}
          >
            More
          </button>
          {moreOpen ? (
            <div className="workspace-more-menu" role="menu">
              {overflow.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  role="menuitem"
                  className={active === tab.id ? 'is-active' : undefined}
                  onClick={() => {
                    onChange(tab.id);
                    setMoreOpen(false);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
